import poApi from "../api/poApi";
import { getCurrentAuthUser } from "./authorization";
import createCache from "./localStorageCache";

const poCache = createCache("detailedPos"); // same key as before — existing cache survives

const findPo = async (poId, callbackWithRemoteResult = () => {}) => {
  const cached = poCache.get(poId);
  const remotePromise = getPoFromCm(poId);

  if (!cached) {
    const remote = await remotePromise;
    poCache.set(poId, remote);
    return remote;
  }

  remotePromise.then((result) => {
    poCache.set(poId, result);
    callbackWithRemoteResult(result);
  });

  return cached;
};

const getPoFromCm = async (poId) => {
  const authInfo = await getCurrentAuthUser();
  return poApi
    .getOpenPoOnCm(authInfo.plant.netsuiteCmId, poId)
    .then((result) => {
      if (result.data.status === "success") {
        return result.data.data.pos[0];
      }
      alert("Error");
      return undefined;
    });
};

export default findPo;